export default {
  hasMasterIdFromStyle: true,
  hasProductSeason: true
}
